module.exports = __webpack_public_path__ + "static/media/mediumIcon.3ef2a004.svg";